import getDefaultHeader from 'lowcode/utils/service/getDefaultHeader';
import { baseUrl } from '../util';
import request from '@/utils/request';

export const getProductFaq = (params: any, locale: string) => {
    return request(`${baseUrl(locale)}/faqInfoForWeb/faqInfo/v2/bySpuId`, {
        method: 'get',
        params,
    });
};
